module.exports = __webpack_public_path__ + "static/media/american.e7e1b67e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/payment-methods/american.png
// module id = 1303
// module chunks = 0